import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./creatifa.css";
// Animate on Scroll
import AOS from "aos";
import "aos/dist/aos.css";

import LandingPage from "./components/landingpage/LPSection1";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

class App extends Component {
  initAos() {
    AOS.init({
      easing: "ease-in-out-back",
      duration: 1000,
      once: true,
    });

    window.addEventListener("load", function () {
      AOS.refresh();
    });

    document
      .querySelectorAll("img")
      .forEach((img) => img.addEventListener("load", () => AOS.refresh()));
  }

  render() {
    return (
      <BrowserRouter basename={baseUrl}>
        <div>
          <Header />
          <Switch>
            <Route exact path="/" component={LandingPage} />
            <Route exact path="/landing-page" component={LandingPage} />
            <Route exact path="/mimin/login" component={AdminLogin} />
            <Route exact path="/mimin/index" component={AdminDashboard} />
          </Switch>
          <Footer />
          {this.initAos()}
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
